// Redes sociais oficiais da Contabeleza. Cada rede só é exibida quando possui URL válida.
// Para ativar uma nova rede, basta preencher handle e url.
export const SOCIALS = [
    {
        id: "instagram",
        label: "Instagram",
        handle: "@grupocontabeleza",
        url: "https://www.instagram.com/grupocontabeleza/",
    },
    { id: "tiktok", label: "TikTok", handle: "", url: "" },
    { id: "linkedin", label: "LinkedIn", handle: "", url: "" },
    { id: "youtube", label: "YouTube", handle: "", url: "" },
];
